import { Component, Input, OnInit } from '@angular/core';
import { CriminalReportService } from '../../services/criminal-report.service';
import { InternalReportService } from '../../services/internal-report.service';
import { LookupService } from '../../services/lookup.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { Role } from '../../services/role.service';
import { CaseService } from '../../services/case.service';

@Component({
  selector: 'app-related-cases',
  templateUrl: './related-cases.component.html',
  styleUrls: ['./related-cases.component.scss']
})
export class RelatedCasesComponent implements OnInit {

  @Input() eCaseId: any;
  @Input() caseType: any;
  relatedCasesArr: any = [];
  message: any;
  caseTypeId: any;
  caseTypesArr: any = [];
  description: any;
  public RoleEnum = Role;
  caseDetails: any;
  AddRelatedCaseShow: boolean = false;

  constructor(public sharedService: SharedHttpService, private caseService: CaseService, private lookupservice: LookupService, public criminalRservice: CriminalReportService, public internalRservice: InternalReportService) { }

  ngOnInit(): void {
    this.caseDetails = this.caseService.case;

    this.sharedService.get(`api/Case/GetRelated?eCaseId=${this.eCaseId}`).subscribe(res => {
      this.relatedCasesArr = res;
    })
    this.caseTypesArr = this.lookupservice.getLockup("casestypes");

  }
  openCreateModal() {
    this.AddRelatedCaseShow = true;
  }
  AddRelatedCase(modal) {
    let obj = {
      "eCaseId": this.eCaseId,
      "caseTypeId": this.caseTypeId,
      "description": this.description
    };
    this.sharedService.post(`api/Case/AddRelatedCase`, obj).subscribe(res => {
      this.caseTypeId = undefined;
      this.description = undefined;

      if (res.isSuccess === true) {

        this.message = res.message;
        this.sharedService.get(`api/Case/GetRelated?eCaseId=${this.eCaseId}`).subscribe(resArr => {
          this.relatedCasesArr = resArr;
          this.sharedService.openLarge(modal);
        });
        this.AddRelatedCaseShow = false;

      } else {
        this.sharedService.showErrorKey(res.message);
      }

    }, err => {
      this.sharedService.showErrorKey("SomethingWentWrong");

    });

  }
}
